import { z } from "zod";
// ============================================================================
// Free Text Check — Request / Response schemas
// ============================================================================
export const FreeTextCheckPayloadSchema = z.object({
    text: z.string().min(1).max(5000),
    exerciseInstructions: z.string().max(2000).optional(),
    exercise_id: z.number().int().positive().optional(),
    courseName: z.string().max(200).optional(),
    moduleName: z.string().max(200).optional(),
    courseLevel: z.string().max(20).optional(),
});
export const FreeTextCheckSentenceSchema = z.object({
    original: z.string(),
    corrected: z.string(),
    is_correct: z.boolean(),
    feedback: z.string(),
});
export const FreeTextCheckResultSchema = z.object({
    overall_score: z.number().min(0).max(100),
    overall_feedback: z.string(),
    sentences: z.array(FreeTextCheckSentenceSchema),
});
